import { createSelector } from "reselect";
import { RootState } from "../../types/store";

const getPaymentState = ({ payment }: RootState) => payment;

export const paymentSelector = createSelector(
  [getPaymentState],
  (payment) => payment
);
